module.exports = !require('./_descriptors') && !require('./_fails')(function () {
  return Object.defineProperty(require('./_dom-create')('div'), 'a', { get: function () { return 7; } }).a != 7;
});



//////////////////
// WEBPACK FOOTER
// /home/caligram/admin.caligram.com/shared/~/babel-polyfill/~/core-js/modules/_ie8-dom-define.js
// module id = 556
// module chunks = 0